import { LogLevel } from 'typescript-logging';
import { Category, CategoryProvider } from 'typescript-logging-category-style';
import { LoggerBaseService } from './logger.base.service';
const kDefaultLogProviderName = 'OwAppLogProvider';

// -----------------------------------------------------------------------------
export class LoggerService extends LoggerBaseService {
  private static logProvider: CategoryProvider =
    CategoryProvider.createProvider(kDefaultLogProviderName, {
      level: LogLevel.Info,
    });

  // ---------------------------------------------------------------------------
  public static setup(providerName: string) {
    LoggerService.logProvider = CategoryProvider.createProvider(providerName, {
      level: LogLevel.Info,
    });
  }

  // ---------------------------------------------------------------------------
  public static getCategory(categoryName: string): Category {
    const category = LoggerService.logProvider.getCategory(categoryName);
    if (super.assignCustomLogger(category)) {
      return category;
    }

    return {
      ...category,
      debug: (...msg) => category.debug(this.mapMessage(...msg)),
      error: (...msg) => category.error(this.mapMessage(...msg)),
      info: (...msg) => category.info(this.mapMessage(...msg)),
      trace: (...msg) => category.trace(this.mapMessage(...msg)),
      warn: (...msg) => category.warn(this.mapMessage(...msg)),
      name: category.name,
    };
  }

  // ---------------------------------------------------------------------------
  private static mapMessage(...message: string[]) {
    return `${message.join(' - ')}`;
  }
}
